import { Reducer } from 'redux';

import {
    DashboardSeenNotificationsState,
    UpdateDashboardSeenNotificationAction,
    GetDashboardSeenNotificationsSuccessAction,
    DashboardSeenNotificationsActionTypes,
} from './types';

const defaultState: DashboardSeenNotificationsState = {
    list: null,
    isLoaded: false,
};
const reducer: Reducer<DashboardSeenNotificationsState> = (
    state: DashboardSeenNotificationsState = defaultState,
    action
): DashboardSeenNotificationsState => {
    switch (action.type) {
        case DashboardSeenNotificationsActionTypes.GET_DASHBOARD_SEEN_NOTIFICATIONS:
            return { ...state, ...{ isLoaded: false } };
        case DashboardSeenNotificationsActionTypes.GET_DASHBOARD_SEEN_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                isLoaded: true,
                list: (action as GetDashboardSeenNotificationsSuccessAction).payload.notifications,
            };
        case DashboardSeenNotificationsActionTypes.UPDATE_DASHBOARD_SEEN_NOTIFICATION:
            return {
                ...state,
                isLoaded: true,
                list: state.list?.includes((action as UpdateDashboardSeenNotificationAction).payload.notification)
                    ? state.list
                    : [...(state.list ?? []), (action as UpdateDashboardSeenNotificationAction).payload.notification],
            };
        default:
            return state;
    }
};

export { reducer as dashboardSeenNotifications };

export default reducer;
